export default "__VITE_ASSET__CNzQyb5u__"